import {
  HiOutlineFire,
  HiOutlinePlayCircle,
  HiOutlineAdjustmentsHorizontal,
  HiOutlineArchiveBox,
  HiOutlineArrowDownRight,
  HiOutlineArrowLeft,
  HiOutlineArrowRight,
  HiOutlineArrowTopRightOnSquare,
  HiOutlineArrowUpRight,
  HiOutlineArrowUturnLeft,
  HiOutlineArrowUturnRight,
  HiOutlineArrowRightOnRectangle,
  HiOutlineArrowTrendingUp,
  HiOutlineArrowTrendingDown,
  HiOutlineBars3,
  HiOutlineViewColumns,
  HiOutlineBell,
  HiOutlineBellSlash,
  HiOutlineBolt,
  HiOutlineBriefcase,
  HiOutlineCalendar,
  HiOutlineCamera,
  HiOutlineChartBar,
  HiOutlineChartPie,
  HiOutlineCheck,
  HiOutlineCheckCircle,
  HiOutlineChevronDown,
  HiOutlineChevronLeft,
  HiOutlineChevronRight,
  HiOutlineChevronUp,
  HiOutlineCircleStack,
  HiOutlineClock,
  HiOutlineCodeBracket,
  HiOutlineCog6Tooth,
  HiOutlineCpuChip,
  HiOutlineCreditCard,
  HiOutlineCurrencyDollar,
  HiOutlineCursorArrowRays,
  HiOutlineDocument,
  HiOutlineDocumentText,
  HiOutlineEllipsisHorizontal,
  HiOutlineEllipsisVertical,
  HiOutlineEnvelope,
  HiOutlineExclamationCircle,
  HiOutlineExclamationTriangle,
  HiOutlineEye,
  HiOutlineEyeSlash,
  HiOutlineChatBubbleLeftRight,
  HiOutlineChatBubbleOvalLeft,
  HiOutlineComputerDesktop,
  HiOutlineForward,
  HiOutlineMegaphone,
  HiOutlineNumberedList,
  HiOutlineTrophy,
  HiOutlineFaceSmile,
  HiOutlineRocketLaunch,
  HiOutlineFlag,
  HiOutlineFolder,
  HiOutlineFolderPlus,
  HiOutlineFunnel,
  HiOutlineGlobeAlt,
  HiOutlineHashtag,
  HiOutlineHeart,
  HiOutlineHome,
  HiOutlineInboxArrowDown,
  HiOutlineInformationCircle,
  HiOutlineKey,
  HiOutlineLink,
  HiOutlineLockClosed,
  HiOutlineLockOpen,
  HiOutlineMagnifyingGlass,
  HiOutlineMagnifyingGlassMinus,
  HiOutlineMagnifyingGlassPlus,
  HiOutlineMapPin,
  HiOutlineMicrophone,
  HiOutlineMinus,
  HiOutlineMoon,
  HiOutlineMusicalNote,
  HiOutlinePaperAirplane,
  HiOutlinePaperClip,
  HiOutlinePause,
  HiOutlinePauseCircle,
  HiOutlinePencil,
  HiOutlinePhone,
  HiOutlinePhoto,
  HiOutlinePlay,
  HiOutlinePlus,
  HiOutlinePower,
  HiOutlineQrCode,
  HiOutlineQuestionMarkCircle,
  HiOutlineRectangleStack,
  HiOutlineArrowPath,
  HiOutlineServerStack,
  HiOutlineShare,
  HiOutlineShieldCheck,
  HiOutlineShoppingBag,
  HiOutlineSlash,
  HiOutlineStar,
  HiOutlineStopCircle,
  HiOutlineSun,
  HiOutlineTag,
  HiOutlineTrash,
  HiOutlineTruck,
  HiOutlineUser,
  HiOutlineUserPlus,
  HiOutlineUsers,
  HiOutlineVideoCamera,
  HiOutlineWifi,
  HiOutlineWrench,
  HiOutlineXCircle,
  HiOutlineXMark,
  HiOutlineSquares2X2,
  HiOutlineCube,
  HiOutlineArrowDownTray,
  HiOutlineArrowUpTray,
  HiOutlineClipboardDocument,
  HiOutlineBookmarkSquare,
  HiOutlineListBullet,
  HiOutlineDevicePhoneMobile,
  HiOutlineDeviceTablet,
  HiOutlineArrowsPointingOut,
  HiOutlineArrowsPointingIn,
} from 'react-icons/hi2'

import type { IconPack } from '../types'

export const heroiconsPack: IconPack = {
  // Navigation
  'home': HiOutlineHome,
  'menu': HiOutlineBars3,
  'panel-left': HiOutlineViewColumns,
  'chevron-down': HiOutlineChevronDown,
  'chevron-left': HiOutlineChevronLeft,
  'chevron-right': HiOutlineChevronRight,
  'chevron-up': HiOutlineChevronUp,
  'arrow-left': HiOutlineArrowLeft,
  'arrow-right': HiOutlineArrowRight,
  'arrow-up-right': HiOutlineArrowUpRight,
  'arrow-down-right': HiOutlineArrowDownRight,
  'corner-up-left': HiOutlineArrowUturnLeft,
  'corner-up-right': HiOutlineArrowUturnRight,
  'external-link': HiOutlineArrowTopRightOnSquare,
  'log-out': HiOutlineArrowRightOnRectangle,
  'globe': HiOutlineGlobeAlt,
  'map-pin': HiOutlineMapPin,

  // Actions
  'plus': HiOutlinePlus,
  'minus': HiOutlineMinus,
  'x': HiOutlineXMark,
  'check': HiOutlineCheck,
  'check-circle': HiOutlineCheckCircle,
  'check-square': HiOutlineBookmarkSquare,
  'x-circle': HiOutlineXCircle,
  'search': HiOutlineMagnifyingGlass,
  'zoom-in': HiOutlineMagnifyingGlassPlus,
  'zoom-out': HiOutlineMagnifyingGlassMinus,
  'filter': HiOutlineFunnel,
  'refresh': HiOutlineArrowPath,
  'download': HiOutlineArrowDownTray,
  'upload': HiOutlineArrowUpTray,
  'share': HiOutlineShare,
  'copy': HiOutlineClipboardDocument,
  'edit': HiOutlinePencil,
  'trash': HiOutlineTrash,
  'archive': HiOutlineArchiveBox,
  'send': HiOutlinePaperAirplane,
  'maximize': HiOutlineArrowsPointingOut,
  'minimize': HiOutlineArrowsPointingIn,
  'mouse-pointer': HiOutlineCursorArrowRays,
  'power': HiOutlinePower,

  // Communication
  'mail': HiOutlineEnvelope,
  'inbox': HiOutlineInboxArrowDown,
  'message-circle': HiOutlineChatBubbleLeftRight,
  'message-square': HiOutlineChatBubbleOvalLeft,
  'phone': HiOutlinePhone,
  'video': HiOutlineVideoCamera,
  'flame': HiOutlineFire,
  'youtube': HiOutlinePlayCircle,
  'mic': HiOutlineMicrophone,
  'bell': HiOutlineBell,
  'bell-off': HiOutlineBellSlash,

  // Media & Content
  'image': HiOutlinePhoto,
  'camera': HiOutlineCamera,
  'file': HiOutlineDocument,
  'file-text': HiOutlineDocumentText,
  'folder': HiOutlineFolder,
  'folder-plus': HiOutlineFolderPlus,
  'paperclip': HiOutlinePaperClip,
  'link': HiOutlineLink,
  'music': HiOutlineMusicalNote,
  'play': HiOutlinePlay,
  'pause': HiOutlinePause,
  'pause-circle': HiOutlinePauseCircle,
  'stop-circle': HiOutlineStopCircle,
  'skip-forward': HiOutlineForward,

  // Data & Analytics
  'bar-chart': HiOutlineChartBar,
  'pie-chart': HiOutlineChartPie,
  'trending-up': HiOutlineArrowTrendingUp,
  'trending-down': HiOutlineArrowTrendingDown,
  'target': HiOutlineRocketLaunch,
  'megaphone': HiOutlineMegaphone,
  'award': HiOutlineTrophy,
  'database': HiOutlineCircleStack,
  'grid': HiOutlineSquares2X2,
  'columns': HiOutlineViewColumns,
  'list': HiOutlineListBullet,
  'list-ordered': HiOutlineNumberedList,
  'hash': HiOutlineHashtag,
  'layers': HiOutlineRectangleStack,
  'sliders': HiOutlineAdjustmentsHorizontal,

  // Users & People
  'user': HiOutlineUser,
  'user-plus': HiOutlineUserPlus,
  'users': HiOutlineUsers,
  'smile': HiOutlineFaceSmile,

  // Business & Commerce
  'briefcase': HiOutlineBriefcase,
  'shopping-bag': HiOutlineShoppingBag,
  'credit-card': HiOutlineCreditCard,
  'dollar-sign': HiOutlineCurrencyDollar,
  'tag': HiOutlineTag,
  'truck': HiOutlineTruck,
  'box': HiOutlineCube,

  // Security & Status
  'lock': HiOutlineLockClosed,
  'unlock': HiOutlineLockOpen,
  'slash': HiOutlineSlash,
  'key': HiOutlineKey,
  'shield': HiOutlineShieldCheck,
  'eye': HiOutlineEye,
  'eye-off': HiOutlineEyeSlash,
  'alert-circle': HiOutlineExclamationCircle,
  'alert-triangle': HiOutlineExclamationTriangle,
  'info': HiOutlineInformationCircle,
  'help-circle': HiOutlineQuestionMarkCircle,
  'flag': HiOutlineFlag,

  // Settings & Tools
  'settings': HiOutlineCog6Tooth,
  'tool': HiOutlineWrench,
  'code': HiOutlineCodeBracket,
  'cpu': HiOutlineCpuChip,
  'server': HiOutlineServerStack,
  'wifi': HiOutlineWifi,
  'smartphone': HiOutlineDevicePhoneMobile,
  'qr-code': HiOutlineQrCode,
  'tablet': HiOutlineDeviceTablet,
  'calendar': HiOutlineCalendar,
  'clock': HiOutlineClock,

  // Appearance
  'sun': HiOutlineSun,
  'moon': HiOutlineMoon,
  'heart': HiOutlineHeart,
  'star': HiOutlineStar,
  'zap': HiOutlineBolt,

  // Social / Brand
  'monitor': HiOutlineComputerDesktop,

  // Specialty
  'more-horizontal': HiOutlineEllipsisHorizontal,
  'more-vertical': HiOutlineEllipsisVertical,
}
